// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3ob6s","left":"StickyBox_left__1gbgp","right":"StickyBox_right__CSnLp"};